import { FC } from "react";
import { ButtonProps } from "./types";

const Button: FC<ButtonProps> = ({
  children,
  props,
  style,
  onClick = () => {},
  loading = false,
}) => {
  const handleClick = (): void => {
    if (!loading) onClick();
  };
  return (
    <button
      onClick={handleClick}
      style={{ ...styles.container, ...style }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;

const styles: Record<string, React.CSSProperties> = {
  container: {
    background: "#1D90F5",
    color: "white",
    height: 40,
    borderRadius: 30,
    width: 250,
    fontFamily: "IranSansBold",
    cursor: "pointer",
  },
};
